import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.54167 3.33325C2.51354 3.33325 1.66667 4.18013 1.66667 5.20825V14.7916C1.66667 15.8197 2.51354 16.6666 3.54167 16.6666H16.4583C17.4865 16.6666 18.3333 15.8197 18.3333 14.7916V7.29159C18.3333 6.26346 17.4865 5.41659 16.4583 5.41659H10.0179L8.15511 3.86466C7.74336 3.52163 7.22465 3.33325 6.68864 3.33325H3.54167ZM3.54167 4.58325H6.68864C6.93263 4.58325 7.16773 4.66882 7.35514 4.82495L8.8151 6.04159L7.35514 7.25822C7.16773 7.41435 6.93263 7.49992 6.68864 7.49992H2.91667V5.20825C2.91667 4.85554 3.18896 4.58325 3.54167 4.58325ZM10.0179 6.66659H16.4583C16.811 6.66659 17.0833 6.93888 17.0833 7.29159V14.7916C17.0833 15.1443 16.811 15.4166 16.4583 15.4166H3.54167C3.18896 15.4166 2.91667 15.1443 2.91667 14.7916V8.74992H6.68864C7.22465 8.74992 7.74336 8.56154 8.15511 8.21851L10.0179 6.66659Z"
          fill="#7A8499"
        />
      </svg>
    </>
  );
};
